/**
 * Format person name + location for view/list pages.
 * Prefers explicit display fields from the API when present.
 */
export function formatUsernameLocation(username, location, fallback = '—') {
  const name = (username || '').toString().trim();
  const loc = (location || '').toString().trim();
  if (name && loc) return `${name} (${loc})`;
  if (name) return name;
  if (loc) return loc;
  const fb = (fallback ?? '').toString().trim();
  return fb || '—';
}

function auditPersonName(record, prefix) {
  return (
    record[`${prefix}_name`] ||
    record[`${prefix}_username`] ||
    record[prefix] ||
    ''
  );
}

/**
 * Resolve Created By / Updated By style fields from an API record.
 * Uses *_display / *_name / *_username / *_location when available.
 */
export function formatAuditUser(record, prefix = 'created_by') {
  if (!record) return '—';
  const display = record[`${prefix}_display`];
  if (display) return display;
  return formatUsernameLocation(
    auditPersonName(record, prefix),
    record[`${prefix}_location`],
    record[prefix]
  );
}

/** Single field: full name-location hub-role */
export function formatAuditUserHubRole(record, prefix = 'created_by') {
  if (!record) return '—';
  const parts = [
    auditPersonName(record, prefix),
    record[`${prefix}_location`],
    record[`${prefix}_role`],
  ]
    .map((v) => (v == null ? '' : String(v).trim()))
    .filter(Boolean);
  if (parts.length) return parts.join('-');
  return formatAuditUser(record, prefix);
}
